// Copyright (c) Konnecta Systems. All rights reserved.
// Licensed under the Custom License. See LICENSE file in the project root for full license information.
// This was autogenerated by zAppDev.
import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class SalaryPaymentSeedLineDTO  {
    _originalTypeClassName = "Loom.BO.SalaryPaymentSeedLineDTO";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
SalaryPaymentSeedLineDTO.translate = translateService;
}
this.Type = null;
this.TotalCost = null;
this.SocialSecurityAmount = null;
this.TaxAmount = null;
this.GrossAmount = null;
this.SalaryPaymentSeedLineDTOKey = null;
this._key = this.SalaryPaymentSeedLineDTOKey = 0; 
}

static translate: TranslateService;
_key: any;
Type:any;
TotalCost:any;
SocialSecurityAmount:any;
TaxAmount:any;
GrossAmount:any;
EmploymentContract:any;
Benefit:any;
private _SalaryPaymentSeedLineDTOKey:any;
get SalaryPaymentSeedLineDTOKey(): any {
    return this._SalaryPaymentSeedLineDTOKey;
  }
set SalaryPaymentSeedLineDTOKey(value: any) {
    this._SalaryPaymentSeedLineDTOKey = value;
    this._key = value;
  }
static setEmploymentContract = ($this, value) => {
var oldValue = $this.EmploymentContract;
$this.EmploymentContract = value;
if (value != null) {
}
}
static setBenefit = ($this, value) => {
var oldValue = $this.Benefit;
$this.Benefit = value;
if (value != null) {
}
}


static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.SalaryPaymentSeedLineDTOKey == null || $this.SalaryPaymentSeedLineDTOKey == 0;
            }


}